import api, { ApiResponse } from './api';

import { ClassificationClass } from 'entities/ClassificationClass';

interface GetClassificationClassListResponse {
  success: boolean;
  data: ClassificationClass[];
}

export const getClassificationClassListService =
  (): ApiResponse<GetClassificationClassListResponse> =>
    api({
      method: 'GET',
      url: 'classification-classes',
      useToken: true,
    });
